<template>
  <a href="https://line.me/ti/p/~@yds1326c">
    <a-button size="large">
        <template #icon><img :src="require('../../assets/lineLogo.png')" width="24"></template>
        &nbsp;聯絡我們
    </a-button>
  </a>
</template>

<script>
export default {
  name: 'Contact',
}
</script>